// Based on: https://gist.github.com/crispinheneise/3973b2816fa9a4e54f818219fbc0988c

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['url'];

  visit() {
    if (this.isIframed()) {
      // In the Admin frontend click events are beeing catched,
      // so don't do anything if we are in an IFRAME
    } else if (typeof window.Turbo !== 'undefined') {
      window.Turbo.visit(this.url);
    } else {
      window.location = this.url;
    }
  }

  get url() {
    return this.targets.find('url').getAttribute('data-href');
  }

  // Is the current document displayed in an IFRAME?
  isIframed() {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  }
}
